<template>
  <div>
    <div v-for="(text, id) of Object.values(params.value)" :key="id">
      {{ text }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
a {
  width: 100%;
  display: block;

  &:hover {
    color: var(--hover-color);
  }
}
</style>